module.exports = __webpack_public_path__ + "static/media/Mazaya Still 02-mobile.e00500a6.webp";